import { AnyBlock, BlockType } from '@/lib/types';
import TextBlock from './text-block';
import NumberBlock from './number-block';
import DateBlock from './date-block';
import SelectionBlock from './selection-block';
import SectionBlock from './section-block';
import LongTextBlock from './long-text-block';
import CreateMediaBlock from './create-media-block';
import EditMediaBlock from './edit-media-block';
import CheckboxBlock from './checkbox-block';
import LinkBlock from './link-block';
import SectionTitleBlock from './section-title-block';

interface Props {
  block: AnyBlock;
  contentId?: string;
}

export default function BlockFromType({ block, contentId }: Props) {
  switch (block.field_type) {
    case BlockType.Text:
      return <TextBlock block={block} />;
    case BlockType.Numeric:
      return <NumberBlock block={block} />;
    case BlockType.Date:
      return <DateBlock block={block} />;
    case BlockType.LongText:
      return <LongTextBlock block={block} />;
    case BlockType.Media:
      if (contentId) {
        return <EditMediaBlock block={block} />;
      }
      return <CreateMediaBlock block={block} />;
    case BlockType.Selection:
      return <SelectionBlock block={block} />;
    case BlockType.Section:
      return <SectionBlock block={block} />;
    case BlockType.Checkbox:
      return <CheckboxBlock block={block} />;
    case BlockType.Link:
      return <LinkBlock block={block} />;
    case BlockType.SectionTitle:
      return <SectionTitleBlock block={block} />;
    default:
      return null;
  }
}
